import React from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, Table, Row, Col } from 'antd';
import moment from 'moment';

const PaymentDetailsModal = ({ open, onCancel, payments }) => {
  const { t } = useTranslation();

  const totalAmount = payments.reduce((total, payment) => total + payment.amount, 0);

  const columns = [
    {
      title: t('subscriptions.credits'),
      dataIndex: 'amount',
      key: 'amount',
    },
    {
      title: t('subscriptions.date'),
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (createdAt) => moment(createdAt).format('DD.MM.YYYY HH:mm'),
    },
  ];

  const tableFooter = () => (
    <Row justify="end">
      <Col span={24} style={{ fontWeight: 'bold' }}>
        {t('subscriptions.total')}: {totalAmount}
      </Col>
    </Row>
  );

  return (
    <Modal
      title={t('subscriptions.payments')}
      open={open}
      onCancel={onCancel}
      footer={null}
      width={500}
    >
      {payments && payments.length > 0 ? (
        <Table
          dataSource={payments}
          columns={columns}
          rowKey="id"
          pagination={false}
          footer={tableFooter}
        />
      ) : (
        <div>{t('subscriptions.paymentEmpty')}</div>
      )}
    </Modal>
  );
};

export default PaymentDetailsModal;